module.exports = __webpack_public_path__ + "static/img/guide_img_22.736c5818.jpg";